var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.button
    ? _c(
        "button",
        {
          staticClass: "highlight-link",
          class: [
            _vm.getButtonType,
            _vm.getButtonStyle,
            _vm.getIconPosition,
            _vm.getButtonSize,
            _vm.getBlock,
          ],
          attrs: {
            target: _vm.targetNewWindow,
            rel: _vm.buttonRel,
            disabled: _vm.disabled === true,
          },
          on: {
            click: function ($event) {
              return _vm.$emit("clicked")
            },
          },
        },
        [
          _vm.hasIcon(_vm.icon)
            ? [_c("highlight-button-icons", { attrs: { icon: _vm.icon } })]
            : _vm._e(),
          _vm._v(" "),
          _vm.title ? _c("span", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
        ],
        2
      )
    : _c(
        "a",
        {
          staticClass: "highlight-link",
          class: [
            _vm.getButtonType,
            _vm.getButtonStyle,
            _vm.getIconPosition,
            _vm.getButtonSize,
            _vm.getBlock,
          ],
          attrs: {
            href: _vm.url,
            target: _vm.targetNewWindow,
            rel: _vm.buttonRel,
          },
          on: {
            click: function ($event) {
              return _vm.$emit("clicked")
            },
          },
        },
        [
          _vm.hasIcon(_vm.icon)
            ? [_c("highlight-button-icons", { attrs: { icon: _vm.icon } })]
            : _vm._e(),
          _vm._v(" "),
          _vm.title ? _c("span", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }